/* COH Glas-Konfigurator – Warenkorb: Fassung und Gläser gemeinsam hinzufügen, Gruppen gemeinsam ändern/entfernen. */
(function () {
  'use strict';
  var prevFetch = window.fetch;
  /* Auf Produktseiten mit Konfigurator liefern GC_DATA und GC_API die Daten; im Warenkorb reicht die Gruppenlogik. */
  function cfg() { return window.GC_DATA && window.GC_API ? { D: window.GC_DATA, A: window.GC_API } : null; }

  /* ---------- Warenkorb-Aufrufe abfangen ---------- */
  function fake(msg) {
    return Promise.resolve(new Response(JSON.stringify({ status: 422, message: 'Gläser', description: msg }), { status: 200, headers: { 'Content-Type': 'application/json' } }));
  }
  function addGlass(fd, A) {
    var errs = A.validate();
    if (errs.length) { A.showErrors(errs); return fake(errs[0]); }
    var s = A.state();
    var group = A.uid();
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var base = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.*)\]$/.exec(k);
      if (m) base[m[1]] = v;
    });
    /* Shopify legt neue Positionen oben ab: zuerst die Gläser, zuletzt die Fassung, dann steht die Fassung oben */
    var items = [];
    A.lines().slice().reverse().forEach(function (l) {
      items.push({ id: l.id, quantity: qty, properties: { _glas_gruppe: group, _glas_rolle: 'glas' } });
    });
    items.push({ id: parseInt(fd.get('id'), 10), quantity: qty, properties: A.frameProps(base, s, group) });
    var body = { items: items };
    if (fd.get('sections')) body.sections = fd.get('sections');
    if (fd.get('sections_url')) body.sections_url = fd.get('sections_url');
    var base_url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return prevFetch.call(window, base_url.replace(/\.js$/, '') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function inGroup(it, gid) { return !!(it.properties && it.properties._glas_gruppe === gid); }
  function isGlassLine(it) { return !!(it.properties && it.properties._glas_rolle === 'glas'); }

  function changeGrouped(input, init) {
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return prevFetch.call(window, input, init); }
    return prevFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = body.line ? cart.items[body.line - 1] : cart.items.filter(function (x) { return x.key === body.id || String(x.id) === String(body.id); })[0];
        var gid = item && item.properties && item.properties._glas_gruppe;
        if (!gid) return prevFetch.call(window, input, init);
        var q = Number(body.quantity);
        if (q > 0 && typeof CART_MAX_ITEMS === 'number') {
          var others = cart.items.reduce(function (n, x) { return n + (isGlassLine(x) || inGroup(x, gid) ? 0 : x.quantity); }, 0);
          var allowed = Math.max(1, CART_MAX_ITEMS - others);
          if (q > allowed) {
            q = allowed;
            if (typeof showCartLimitToast === 'function') showCartLimitToast();
          }
        }
        var updates = {};
        cart.items.forEach(function (x) { if (inGroup(x, gid)) updates[x.key] = q; });
        var payload = { updates: updates };
        if (body.sections) payload.sections = body.sections;
        if (body.sections_url) payload.sections_url = body.sections_url;
        return prevFetch.call(window, '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
      });
  }

  /* ---------- Darstellung im Warenkorb ---------- */
  var GLASS_IDS = ['53890289303818', '53890289336586', '53890289369354', '53890289402122', '53890289434890', '53890289467658', '53890289500426'];
  var st = document.createElement('style');
  st.textContent = 'cart-item[data-gc-glass]{max-height:none!important}' +
    'cart-item[data-gc-glass] .cart-item__image-wrapper,cart-item[data-gc-glass] cart-remove-button,cart-item[data-gc-glass] quantity-component{display:none!important}' +
    'cart-item[data-gc-glass] .cart-item__body{opacity:.85}';
  document.head.appendChild(st);
  function mark() {
    var rows = document.querySelectorAll('cart-item');
    for (var k = 0; k < rows.length; k++) {
      var on = GLASS_IDS.indexOf(rows[k].getAttribute('data-variant-id')) > -1;
      if (on && !rows[k].hasAttribute('data-gc-glass')) rows[k].setAttribute('data-gc-glass', '');
    }
  }
  function refreshCounts() {
    prevFetchRef('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var hasGlass = false, n = 0;
      cart.items.forEach(function (x) {
        if (x.properties && x.properties._glas_rolle === 'glas') hasGlass = true; else n += x.quantity;
      });
      if (!hasGlass) return;
      var bubbles = document.querySelectorAll('.cart-count span');
      for (var k = 0; k < bubbles.length; k++) if (bubbles[k].textContent.trim() !== String(n)) bubbles[k].textContent = n;
      var hd = document.querySelectorAll('.cart-drawer__header-product-count');
      for (var j = 0; j < hd.length; j++) if (hd[j].textContent.indexOf('(' + n + ' ') !== 0) hd[j].textContent = '(' + n + ' Artikel)';
    }).catch(function () { });
  }
  function prevFetchRef() { return window.fetch.apply(window, arguments); }
  var markQueued = false;
  new MutationObserver(function () {
    if (markQueued) return;
    markQueued = true;
    requestAnimationFrame(function () { markQueued = false; mark(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () {
    mark();
    refreshCounts();
    /* Preise im Konfigurator ohne ,00 anzeigen */
    var g = document.getElementById('gc');
    if (g) g.querySelectorAll('.gc__price, .gc__txt em, .gc__gtitle span').forEach(function (e) { e.textContent = e.textContent.replace(/,00(?!\d)/g, ''); });
  });

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var path = url.split('?')[0];
      if (/\/cart\/(add|change|update)(\.js)?$/.test(path)) { setTimeout(refreshCounts, 700); setTimeout(refreshCounts, 1800); }
      var c = cfg();
      if (c && /\/cart\/add(\.js)?$/.test(path) && init && typeof FormData !== 'undefined' && init.body instanceof FormData &&
        String(init.body.get('product-id')) === String(c.D.productId) && c.A.isGlass()) {
        return addGlass(init.body, c.A);
      }
      if (/\/cart\/change(\.js)?$/.test(path) && init && typeof init.body === 'string') {
        return changeGrouped(input, init);
      }
    } catch (e) { }
    return prevFetch.apply(this, arguments);
  };

  /* Absenden sperren, solange Angaben fehlen */
  document.addEventListener('submit', function (ev) {
    var c = cfg();
    var f = ev.target;
    if (!c || !f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var pid = f.querySelector('[name="product-id"]');
    if (pid && String(pid.value) !== String(c.D.productId)) return;
    var A = c.A;
    if (!A.isGlass()) return;
    var errs = A.validate();
    if (errs.length) {
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      A.showErrors(errs);
    } else {
      A.showErrors([]);
    }
  }, true);

})();